import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';

export default function EditDeleteOrderLineDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose={props.closeDialog}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle className={classes.dialogTitle} style={{ cursor: 'move' }} id="draggable-dialog-title">
                {props.edit? "Edit product orderline": "Delete product orderline"}
            </DialogTitle>
            <div className={classes.dialogContext}>
                <div>
                    {props.edit? "Current progress will be lost, are you sure?":"Are you sure you want to delete the orderline?"}
                </div>                
            </div>

            <div className={classes.buttons}>
                <button className={classes.button} onClick={props.edit? () => props.editOrderline():() => props.deleteOrderline()}>
                    {t("YES")}
                </button>
                <button className={classes.button} onClick={() => props.closeDialog()}>
                    {t("NO")}
                </button>
            </div>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "380px !important",
        height: "320px !important",
        margin: "auto",
        "& > div > div": {
            backgroundImage: 'linear-gradient(#EFEFEF,#FFFFFF)',
            maxHeight: "none"
        },
    },
    buttons: {
        textAlign: "center",
    },
    button: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Roboto",
        fontWeight: 'medium',
        backgroundColor: "#1976d2",
        '&:hover': {
            backgroundColor: "#1976d2",
        },
        width: "60px",
        outline: "none",
        border: "none",
        height: "30px",
        cursor: "pointer",
        marginBottom: "30px",
        marginTop: "20px",
        marginLeft:"10px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "20px !important",
        },
        paddingTop: "30px",
        paddingBottom: "20px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingLeft: "20px",
        paddingRight: "20px",
        height: "50px"
    },

    uiTextField: {
        width: "95%",
        backgroundColor: "white"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        textAlign: "left"
    },

}));
